module.exports = __webpack_public_path__ + "img/icon5@2x.f5750f27.png";